import { useTranslation } from "react-i18next";
import ExportReport from "./ExportReport";
import PrintReport from "./PrintReport";
import { useAppSelector } from "app/hooks";
import { selectIsPrinting } from "features/Reports";
import { Typography } from "@mui/material";

function ToolBar() {
  const { i18n } = useTranslation();
  const isPrinting = useAppSelector(selectIsPrinting);
  const customStyles = {
    root: {
      position: "absolute",
      top: "15px",
      ...(i18n.dir() === "rtl" ? { left: "30px" } : { right: "30px" }),
      display: isPrinting ? "none" : "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "60px",
    },
  };

  return (
    <Typography component="div" sx={customStyles.root}>
      <ExportReport />
      <PrintReport />
    </Typography>
  );
}

export default ToolBar;
